import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { ModulesMessages } from '../../../../shared/messages/modulesMessages';
import { OrbitHistoryFilter } from './types';
import { OrbitHistoryFilters } from './filters';
import { OrbitHistoryList } from './list';

export const OrbitHistory = () => {
    const [filters, setFilters] = useState<OrbitHistoryFilter>();

    return (
        <>
            <LayoutModule title={ModulesMessages.ORBIT_HISTORY_PAGE}>
                <OrbitHistoryFilters
                    loading={false}
                    onFilter={(nextFilters) => setFilters(nextFilters)}
                />
            </LayoutModule>
            <OrbitHistoryList filters={filters} />
        </>
    );
};
